import { handleActions } from "redux-actions";

import { margeUserAction, openUserAction, closeUserAction } from "./actions";
import { USER_ACTION_DIALOG_TYPE } from "./constants";

const initialState = {
    dialogType: USER_ACTION_DIALOG_TYPE.Message,
    isLoading: false,
    isOpen: false,
    actionSubject: "",
    actionType: "",
    message: null,
    action: null,
    actionsProps: {}
};

export const userActionReducer = handleActions(
    {
        [openUserAction]: (state, { payload }) => ({
            ...state,
            isOpen: true,
            ...payload
        }),
        [closeUserAction]: (state) => ({
            ...state,
            ...initialState
        }),
        [margeUserAction]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
